import styled from "styled-components";

export const TimeContainer = styled.div`
  .time-picker__control {
    height: 40px;
    background-color: ${({ theme }) => theme.bg.primary};
    border-radius: 8px;
    box-sizing: border-box;
    border: none;
    width: 100%;

    &:focus {
      outline: none;
    }
  }

  .time-picker__single-value {
    color: ${({ theme }) => theme.text.input};
    font-size: 13.3333px;
  }

  svg {
    color: ${({ theme }) => theme.text.input};
  }
`;

export const Preview = styled.span`
  color: ${({ theme }) => theme.text.link};
  font-size: 10px;
  font-weight: 400;
  line-height: 17px;
  user-select: none;
  cursor: pointer;
  display: flex;
  align-items: center;
`;
